import { render, staticRenderFns } from "./newCustomersList.vue?vue&type=template&id=d628834e&scoped=true&"
import script from "./newCustomersList.vue?vue&type=script&lang=js&"
export * from "./newCustomersList.vue?vue&type=script&lang=js&"
import style0 from "./newCustomersList.vue?vue&type=style&index=0&id=d628834e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d628834e",
  null
  
)

export default component.exports